import { StyledSpinner } from './Spinner.styles';

export interface SpinnerProps {
  size?: string;
  'data-testid'?: string;
  variant: 'primary' | 'secondary';
  inLine?: boolean;
}

const SpinnerDefaultProps: SpinnerProps = {
  size: '14px',
  variant: 'primary',
  'data-testid': 'spinner',
};

export const Spinner = (props: Partial<SpinnerProps>) => (
  <StyledSpinner {...SpinnerDefaultProps} {...props} />
);
